import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";
import Skeleton from "react-loading-skeleton";

import { useAllAdvisorRoles } from "../api";

export const AdvisorRoleDropdown = ({ selected, onChange, loading }) => {
  const { data, loading: rolesLoading } = useAllAdvisorRoles({ enabled: true });

  if (loading) {
    return <Skeleton rounded height="32px" width="100%" />;
  }

  return (
    <Dropdown
      className={"advisor-role-dropdown"}
      selected={selected}
      onOptionSelected={onChange}
    >
      <DropdownButton
        placeholder="Select an Advisor Role"
        disabled={rolesLoading}
      >
        {selected}
      </DropdownButton>
      <DropdownItems>
        {data?.map((role) => (
          <DropdownItem key={role} value={role}>
            {role}
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
};
